const defaultPointsCashConfig = { isLoading: true }
const defaultInstallments = { items: [], isLoading: true }

const paymentDefault = {
  pointsCashConfig: defaultPointsCashConfig,
  installments: defaultInstallments,
  isDepreciated: false
}
const defaultState = {
  isLoading: false,
  hasError: false,
  messageError: '',
  payment: paymentDefault,
  confirmedOrderId: undefined,
  authorized: false,
  loadingResendToken: false
}
export default (state = defaultState, action) => {
  switch (action.type) {
    case 'FETCH_POINTS_CASH_CONFIG':
    case 'FETCH_CASH_ONLY_CONFIG':
      return {
        ...state,
        payment: paymentDefault
      }
    case 'FETCH_POINTS_CASH_CONFIG_SUCCESS':
    case 'FETCH_CASH_ONLY_CONFIG_SUCCESS':
      const { data } = action.payload
      const isLoading = false
      let hasError = data.error && data.error.length > 0
      let error = hasError ? data.error[0] : data.error

      if (!hasError && state.hasError) {
        hasError = true
        error = state.messageError
      }

      const payment = {
        ...state.payment,
        pointsCashConfig: { ...data, isLoading }
      }

      return { ...state, payment, hasError, messageError: error }
    case 'FETCH_POINTS_CASH_CONFIG_FAIL':
    case 'FETCH_CASH_ONLY_CONFIG_FAIL':
      return {
        ...state,
        payment: {
          ...state.payment,
          pointsCashConfig: { error: action.error, isLoading: false }
        }
      }
    case 'FETCH_INSTALLMENTS':
      return {
        ...state,
        payment: {
          ...state.payment,
          installments: defaultInstallments
        }
      }
    case 'FETCH_INSTALLMENTS_SUCCESS':
      return {
        ...state,
        payment: {
          ...state.payment,
          installments: { items: [...action.payload.data], isLoading: false }
        }
      }
    case 'FETCH_INSTALLMENTS_FAIL':
      return {
        ...state,
        payment: {
          ...state.payment,
          installments: { error: action.error, isLoading: false }
        }
      }
    case 'CREATE_PURCHASE':
      delete state.errorResend
      return {
        ...state,
        isCreatingPurchase: true,
        status: ''
      }
    case 'CREATE_PURCHASE_SUCCESS':
      const {
        payload: {
          data: { id, status },
          status: statusCode
        }
      } = action
      return {
        ...state,
        isCreatingPurchase: false,
        confirmedOrderId: id,
        status: status,
        statusCode: statusCode,
        secondFactorAuthSuccess: false,
        authorized: !status
      }
    case 'CREATE_PURCHASE_FAIL':
      const { response } = action.error
      const messageError =
        (response &&
          response.data &&
          response.data.errors &&
          response.data.errors.length > 0 &&
          response.data.errors[0].message) ||
        ''
      return {
        ...state,
        isCreatingPurchase: false,
        secondFactorAuthSuccess: false,
        statusCode: response.status,
        hasError: true,
        messageError,
        authorized: false
      }
    case 'CLEAR_PURCHASE_ERROR':
      return {
        ...state,
        hasError: false,
        messageError
      }
    case 'CART_UPDATE_COUPON_SUCCESS': {
      return {
        ...state,
        payment: {
          ...state.payment,
          isDepreciated: true
        }
      }
    }
    case 'CART_REMOVE_COUPON_SUCCESS':
      return {
        ...state,
        payment: {
          ...state.payment,
          isDepreciated: true
        },
        hasError: false,
        titleError: '',
        messageError: ''
      }
    case 'CART_REMOVE_COUPON_FAIL':
      return {
        ...state,
        hasError: true,
        titleError: 'Não foi possível remover o cupom de desconto.',
        messageError: 'Tente novamente.'
      }
    case 'AUTHORIZE_TOKEN':
      return { ...state, isCreatingPurchase: true, authorized: false }
    case 'AUTHORIZE_TOKEN_SUCCESS':
      delete state.errorToken
      let lastTry = action.meta.previousAction && action.meta.previousAction.lastTry
      const {
        payload: {
          data: _status = status.status,
          status: _statusCode = statusCode
        }
      } = action
      return {
        ...state,
        secondFactorAuthSuccess: !(
          _statusCode === 202 && _status.status === 'RequiresTokenValidation'
        ) || lastTry,
        authorized: !_status.status,
        isCreatingPurchase: false,
        status: _status.status,
        statusCode: _statusCode,
        errorToken:
          _statusCode === 202 && _status.status === 'RequiresTokenValidation'
      }
    case 'AUTHORIZE_TOKEN_FAIL':
      delete state.confirmedOrderId
      const { response_ } = action.error
      const messageError_ =
        (response_ &&
          response_.data &&
          response_.data.errors &&
          response_.data.errors.length > 0 &&
          response_.data.errors[0].message) ||
        ''
      return {
        ...state,
        hasError: true,
        authorized: false,
        secondFactorAuthSuccess: false,
        isCreatingPurchase: false,
        messageError_
      }
    case 'AUTHORIZE_RESEND':
      delete state.errorResend
      return { ...state, loadingResendToken: true }
    case 'AUTHORIZE_RESEND_SUCCESS':
      return {
        ...state,
        isCreatingPurchase: false,
        loadingResendToken: false
      }
    case 'AUTHORIZE_RESEND_FAIL':
      const { response: responseR_ } = action.error
      const messageErrorR_ =
        (responseR_ &&
          responseR_.data &&
          responseR_.data.errors &&
          responseR_.data.errors.length > 0 &&
          responseR_.data.errors[0].message) ||
        ''
      let dataStatus = responseR_ && responseR_.data && responseR_.data.status
      let responseRStatus = responseR_ && responseR_.status
      return {
        ...state,
        secondFactorAuthSuccess: false,
        status: dataStatus,
        statusCode: responseRStatus,
        isCreatingPurchase: false,
        errorResend:
          (responseRStatus === 400 || responseRStatus === 500) &&
          dataStatus === 'ResendTokenError',
        messageErrorR_,
        loadingResendToken: false
      }

    case 'AUTHORIZE_TOKEN_LAST_TRY':
      return { ...state, loadingResendToken: true }
    case 'AUTHORIZE_TOKEN_LAST_TRY_SUCCESS':
      return {
        ...state,
        loadingResendToken: false
      }
    case 'AUTHORIZE_TOKEN_LAST_TRY_FAIL':
      delete state.confirmedOrderId
      const { responseL_ } = action.error
      const messageErrorL_ =
        (response_ &&
          responseL_.data &&
          responseL_.data.errors &&
          responseL_.data.errors.length > 0 &&
          responseL_.data.errors[0].message) ||
        ''
      return {
        ...state,
        hasError: true,
        messageErrorL_,
        loadingResendToken: false
      }

    case 'CLOSE_MODAL':
      delete state.confirmedOrderId
      delete state.authorized
      return { ...state, hasError: true }
    case 'SUCCESS':
      delete state.confirmedOrderId
      return { ...state, secondFactorAuthSuccess: false }
    case 'CLEAR_CONFIRMED_ORDER_DATA':
      return defaultState
    default: {
      return { ...state }
    }
  }
}



// WEBPACK FOOTER //
// ./src/features/Checkout/reducer.js